import { withSvgIcon } from './withSvgIcon';

export const Url = withSvgIcon(
  <>
    <path
      d="M10.1151 13.5078L7.93502 15.6878C6.98807 16.6347 5.49452 16.6945 4.60632 15.8063L4.09877 15.2987C3.21691 14.4169 3.26982 12.9301 4.22359 11.9764L7.10532 9.09463C8.05228 8.14767 9.54582 8.08795 10.434 8.97615"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M9.8925 6.30745L12.0589 4.14104C13.0059 3.19408 14.4994 3.13436 15.3876 4.02256L15.8952 4.53011C16.777 5.41197 16.7305 6.90505 15.7767 7.85881L12.8881 10.7474C11.9412 11.6943 10.4476 11.754 9.55944 10.8658"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </>,
  { viewBox: '0 0 20 20' },
);
